import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsModule } from 'node_modules/ng2-charts';

import { CoreRoutingModule } from './core-routing.module';
import { LanguageTranslationModule } from '../shared/modules/language-translation/language-translation.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxLoadingModule } from 'ngx-loading';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { FeedComponent } from './feed/components/feed/feed.component';

import { UsersComponent } from './users/users.component';
import { SettingsComponent } from './settings/settings.component';
import { SignOutComponent } from './sign-out/sign-out-container/sign-out.component';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './dashboard/dashboard-container-component/dashboard.component';
import { TransactionsComponent } from './dashboard/transactions/presentation/smart-transactions/transactions.component';
import { TransactionsJsonServerService } from './dashboard/transactions/core/services/json_server/transactions-json-server.service';
import { TransactionsFacade } from './dashboard/transactions/abstraction/transactions-facade';
import { TransactionsState } from './dashboard/transactions/core/state/transactions.state';
import { TransactionCreationModalComponent } from './dashboard/transactions/presentation/transaction-creation-modal/transaction-creation-modal.component';
import { TransactionDeleteModalComponent } from './dashboard/transactions/presentation/transaction-delete-modal/transaction-delete-modal.component';
import { ChartsComponent } from './dashboard/transactions/presentation/charts/charts.component';
import { AreachartComponent } from './dashboard/transactions/presentation/charts/areachart/areachart.component';
import { BarchartComponent } from './dashboard/transactions/presentation/charts/barchart/barchart.component';
import { PiechartComponent } from './dashboard/transactions/presentation/charts/piechart/piechart.component';
import { AosToken, aos } from './aos';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from 'src/environments/environment';
import { ChatComponent } from './chat/components/chat/chat.component';
import { SideListComponent } from './chat/components/side-list/side-list.component';
import { ChatDetailComponent } from './chat/components/chat-detail/chat-detail.component';
import { PeriodicTransactionCreationModalComponent } from './dashboard/transactions/presentation/pt-creation-modal/periodic-transaction-creation-modal.component';
import { PtransactionsStoreService } from './dashboard/transactions/core/services/fire-store/ptransactions-store.service';
import { TransactionsStoreService } from './dashboard/transactions/core/services/fire-store/transactions-store.service';
import { TransactionsService } from './dashboard/transactions/core/functions/transactions.service';
import { PeriodicTransactionsManager } from './dashboard/transactions/core/functions/periodic-transactions-manager.service';
import { CloudFunctions } from './dashboard/transactions/core/services/cloud-functions/cloud-functions.service';
import { MachineLearningModalComponent } from './dashboard/transactions/presentation/machine-learning-modal/machine-learning-modal.component';
import { BalanceComponent } from './dashboard/transactions/presentation/balance/balance-component/balance.component';
import { ScoreManager } from './dashboard/core/functions/score-manager.service';
import { DashboardFacade } from './dashboard/abstraction/dashboard.facade';
import { DashboardState } from './dashboard/core/state/dashboard.state';
import { SetTargetModalComponent } from './dashboard/transactions/presentation/balance/set-target-modal/set-target-modal.component';
import { FeedDetailComponent } from './feed/components/feed-detail/feed-detail.component';
import { PublicProfileComponent } from './profile/components/public-profile/public-profile.component';
import { ProfileComponent } from './profile/components/profile/profile.component';
import { PrivateProfileComponent } from './profile/components/private-profile/private-profile.component';
import { EditProfileComponent } from './profile/components/edit-profile/edit-profile.component';
import { SignOutModalComponent } from './sign-out/sign-out-modal/sign-out-modal.component';
//Services

@NgModule({
  declarations: [
    AreachartComponent,
    BalanceComponent,
    BarchartComponent,
    ChartsComponent,
    ChatComponent,
    ChatDetailComponent,
    DashboardComponent,
    FeedComponent,
    FeedDetailComponent,
    MachineLearningModalComponent,
    PeriodicTransactionCreationModalComponent,
    PiechartComponent,
    ProfileComponent,
    PublicProfileComponent,
    SetTargetModalComponent,
    SettingsComponent,
    SideListComponent,
    SignOutComponent,
    SignOutModalComponent,
    TransactionCreationModalComponent,
    TransactionDeleteModalComponent,
    TransactionsComponent,
    UsersComponent,
    PrivateProfileComponent,
    EditProfileComponent,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    ChartsModule,
    CommonModule,
    CoreRoutingModule,
    HttpClientModule,
    ImageCropperModule,
    MatCardModule,
    NgxLoadingModule.forRoot({}),
    SharedModule,
    TranslateModule,
  ],
  providers: [
    { provide: AosToken, useValue: aos },
    CloudFunctions,
    DashboardFacade,
    DashboardState,
    PeriodicTransactionsManager,
    PtransactionsStoreService,
    ScoreManager,
    TransactionsFacade,
    TransactionsJsonServerService,
    TransactionsService,
    TransactionsState,
    TransactionsStoreService,
  ],
  entryComponents: [
    MachineLearningModalComponent,
    PeriodicTransactionCreationModalComponent,
    SetTargetModalComponent,
    SignOutModalComponent,
    TransactionCreationModalComponent,
    TransactionDeleteModalComponent,
  ],
})
export class CoreModule {}
